export const SortingOrderTypes = {
  ASC: 'ASC',
  DESC: 'DESC',
};

export const CompulsorySort = {
  TOOLTIP: '*This is pre-applied Sort. Sorting order can not be changed.',
};
